import { createContext, useContext } from 'react';

/**
 * Lets a page-builder image module open the project's photo viewer.
 *
 * The gallery owns the viewer and the ordered list of photographs, but the
 * pictures themselves are drawn deep inside arbitrary CMS modules that know
 * nothing of either. Rather than thread a callback through every module type,
 * the gallery publishes one here and the image shell asks for it.
 *
 * Absent outside the project gallery — the same shell draws the article and
 * professional pages, where a click keeps its old meaning.
 */
export interface ProjectPhotoViewer {
    /**
     * Open on the photograph with this library image ID. Returns false when
     * the gallery has no slide for it, so the caller can fall back.
     */
    openPhotoById: (imageID: number) => boolean;
}

const ProjectPhotoViewerContext = createContext<ProjectPhotoViewer | null>(
    null,
);

export const ProjectPhotoViewerProvider = ProjectPhotoViewerContext.Provider;

export const useProjectPhotoViewer = (): ProjectPhotoViewer | null =>
    useContext(ProjectPhotoViewerContext);
